export const ROUTES = {
  HOME: '/',
  SKILLS: '/skills',
  PROJECTS: '/projects',
  CONTACT: '/contact',
  COMING_SOON: '/coming-soon',
} as const

export type RouteKey = keyof typeof ROUTES
